import { FC } from 'react';
import styles from './styles.module.css';
import clsx from 'clsx';
import { faHome, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { Breadcrumb as AntdBreadcrumb, BreadcrumbProps as AntdBreadcrumbProps } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { routes } from 'types/routes';

export interface BreadcrumbItem {
  content: any;
  href?: string;
}

interface BreadcrumbProps extends AntdBreadcrumbProps {
  className?: string;
  items: BreadcrumbItem[];
}

export const Breadcrumb: FC<BreadcrumbProps> = ({ className, items, ...props }) => {
  return (
    <AntdBreadcrumb
      className={clsx(styles.wrapper, className)}
      separator={<FontAwesomeIcon className={styles.separator} icon={faChevronRight} />}
      {...props}
    >
      <AntdBreadcrumb.Item href={routes.home}>
        <FontAwesomeIcon icon={faHome} />
      </AntdBreadcrumb.Item>
      {items.map((item, pos: number) => (
        <AntdBreadcrumb.Item key={pos} href={item.href} className={styles.item}>
          {item.content}
        </AntdBreadcrumb.Item>
      ))}
    </AntdBreadcrumb>
  );
};
